import React, { useEffect, useState } from "react"
import { useHistory, useParams } from 'react-router-dom';
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon";
import { ThreeColumnContainer, TwoColumnContainer } from "../Shared/Formelements";
import { ScreenHeader } from "../UI/Elements";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { useUsers } from "../../hooks/useUsers";
import { Dialog } from "../Shared/Dialog";
import { useOrganizations } from "./useOrganizations";
import { StringHelper } from "../../Handlers/Helpers";
import { Routes } from "../../Handlers/ViewHandler";
import { OrganizationModelType, organizationReducer, OrganizationUsersModelType } from "../../rdx/organizationReducer";
import { AccountType } from "../../hooks/useAccountsAdmin";
import { ToolBar } from "../ToolBar/ToolBar";
import { MessageBoxes } from "../../Handlers/MessageBoxes";

export const OrganizationsUsers = () => {

    const { id } = useParams();
    const ui = useOrganizationsUsers(id);
    useEffect(() => {
        ui.ensureUsers();
    }, [])



    return (
        <div className="screen-organizations">
            <ScreenHeader text={"Organisation '" + ui.organizationName + "'"} icon={AdminIcons.users} />
            <div>

                <ToolBar tools={[
                    { id: "edit", label: "Redigera användare", icon: AdminIcons.plus, disabled: ui.dialogVisible, onClick: ui.onDialogOpen },
                    { id: "save", label: "Spara användare", icon: AdminIcons.save, disabled: !ui.hasChanged, onClick: ui.onSave },
                ]} />
            </div>
            <div>
                <table className="tbl tbl-small">
                    <thead>
                        <tr>
                            <th>E-Post</th>
                            <th>Alias</th>
                            <th>Roll</th>
                            <th></th>
                            <th></th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        {ui.users?.map(n => (
                            <tr key={n?.id} data-id={n?.id}>
                                <td>{n?.email}</td>
                                <td>{n?.alias}</td>
                                <td>{n?.role}</td>
                                <td>
                                    {n?.role !== "OWNER" && (
                                        <button className="btn-tbl-mini" onClick={async () => {
                                            if (MessageBoxes.confirm("Är du säker?")) {
                                                ui.onMakeOwner(n?.id)
                                            }
                                        }}>Gör till ägare</button>
                                    )}
                                </td>
                                <td>
                                    {n?.role !== "OWNER" && (
                                        <button className="btn-tbl-mini" onClick={async () => {
                                            if (MessageBoxes.confirm("Är du säker?")) {
                                                ui.onRemoveUser(n?.id)
                                            }
                                        }}>Radera</button>
                                    )}
                                </td>
                                <td>
                                    <AdminIcon icon={ui.getUserSavedState(n?.id)?.[0]} color={ui.getUserSavedState(n?.id)?.[1]} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Dialog
                title={"Redigera användare"}
                visible={ui.dialogVisible}
                onOk={ui.onDialogclose}
                okButtonText={"Stäng"}
                width="1000px"
            >
                <div>
                    <label>
                        Sök
                    </label>
                    <input disabled={ui.isSearching} type="text" className="frm" placeholder="Sök" onKeyUp={e => {
                        if (e.key == "Enter") {
                            ui.onSearch(e.currentTarget.value)
                        }
                    }} />
                </div>
                <div>
                    <table className="tbl tbl-small">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Alias</th>
                                <th>E-post</th>
                                <th>Ort</th>
                                <th>Roll</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ui.searchHits?.map(u => (
                                <tr key={u?.id}>
                                    <td>
                                        <input type="checkbox"
                                            checked={ui.dialogUserchecked(u?.id)}
                                            disabled={ui.dialogUserDisabled(u?.id)}
                                            onChange={e => ui.dialogUserChecked(u, e.currentTarget.checked)}
                                        />
                                    </td>
                                    <td>{!!u?.alias ? u?.alias : "FTG: " + u?.email}</td>
                                    <td>{u?.email}</td>
                                    <td>{u?.city}</td>
                                    <td>{ui.users.find(m => m?.id === u?.id)?.role}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Dialog>


        </div>
    )
}



type OrganizationUsersModelTypeExt = OrganizationUsersModelType & {
    status: "nochange" | "removed" | "added";
}

const useOrganizationsUsers = (organiztionId: string) => {

    const ops = useOrganizations();
    const org = ops.organizations?.[organiztionId];


    useEffect(() => {
        if (!!organiztionId) { ops.loadOrgUsers(organiztionId); }
    }, [, organiztionId]);
    const [users, setUsers] = useState<OrganizationUsersModelTypeExt[]>([]);
    const [usersSaved, setUsersSaved] = useState<OrganizationUsersModelTypeExt[]>([]);

    // ensureUsers
    const ensureUsers = () => {
        if (Object.keys(ops.organizationUsers ?? {}).length > 0) {
            const _u = Object.keys(ops.organizationUsers ?? {})
                .map(key => {
                    return {
                        ...ops.organizationUsers?.[key],
                        status: "nochange"
                    } as OrganizationUsersModelTypeExt
                })
                .filter(u => u?.organizationId === organiztionId);
            setUsers(_u);
            setUsersSaved(_u);
        }
    }
    useEffect(() => ensureUsers(), [ops.organizationUsers]);


    // Dialog
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [searchHits, setSearchHits] = useState<AccountType[]>([]);

    const onSearch = async (e: string) => {
        setIsSearching(true);
        const url = "/api/accounts?page=0&pagesize=15&sort=created&search=" + encodeURI(e);
        const us: AccountType[] = await FetchHandler.getJson(url);
        setSearchHits(us);
        setIsSearching(false);
    };


    return {
        ensureUsers: ensureUsers,
        isSearching: isSearching,
        organizationName: org?.name,
        users: users,
        onSearch: onSearch,
        searchHits: searchHits,

        onDialogOpen: () => {
            setSearchHits([]);
            setShowAdd(true);
        },
        onDialogclose: () => {
            setShowAdd(false);
        },
        dialogVisible: showAdd,
        dialogUserchecked: (userId: string) => {
            const u = users.find(m => m?.id === userId);
            if (!u?.status || u?.status == "removed") {
                return false;
            }
            return true;
        },
        dialogUserDisabled: (userId: string) => {
            return !!users.find(m => m?.id === userId && m?.role === "OWNER")
        },
        dialogUserChecked: (user: AccountType, checked: boolean) => {
            const u = users?.find(m => m.id == user?.id);

            console.log("res: ", checked, u?.status);

            if (checked && u?.status == "removed") {
                let _u = [...users];
                _u[_u.findIndex(m => m?.id === user?.id)].status = "added";
                setUsers(_u);
            } else if (checked && u?.status == "nochange") {
            } else if (checked && u?.status == "added") {
                let _u = [...users];
                _u[_u.findIndex(m => m?.id === user?.id)].status = "added";
                setUsers(_u);
            } else if (checked === false && u?.status == "removed") {
            } else if (checked === false && u?.status == "nochange") {
                let _u = [...users];
                _u[_u.findIndex(m => m?.id === user?.id)].status = "removed";
                setUsers(_u);
            } else if (checked === false && u?.status == "added") {
                setUsers([...users.filter(n => n?.id !== user?.id)]);
            } else if (checked === false && !u) {
            } else if (checked && !u) {
                setUsers([...users, {
                    id: user?.id,
                    alias: user?.alias,
                    email: user?.email,
                    role: "MEMBER",
                    organizationId: organiztionId,
                    status: "added"
                }]);
            }

        },
        getUserSavedState: (id: string) => {
            const txt = users.find(m => m.id === id)?.status;
            if (txt === "nochange") { return [AdminIcons.user, "#999"]; }
            else if (txt === "added") { return [AdminIcons.plus, "green"]; }
            else if (txt === "removed") { return [AdminIcons.close, "red"]; }
            else { return ["N/A", "#999"]; }
        },
        hasChanged: users?.filter(m => m?.status == "added" || m?.status == "removed")?.length > 0,
        onSave: async () => {
            const r = users.filter(m => m?.status == "added" || m?.status == "removed")
                .map(m => { return { id: m?.id, status: m?.status } });
            console.log("update users;", r);

            const p = {
                users: r
            };
            const url = "/api/organizations/" + organiztionId + "/users";
            await FetchHandler.patchJson(url, p);

            await ops.loadOrgUsers(organiztionId);
        },
        onRemoveUser: async (uid: string) => {
            const p = {
                users: [{ id: uid, status: "removed" }]
            };
            const url = "/api/organizations/" + organiztionId + "/users";
            await FetchHandler.patchJson(url, p);
            await ops.loadOrgUsers(organiztionId);
        },
        onMakeOwner: async (userId: string) => {
            const p = { ownerid: userId };
            const url = "/api/organizations/" + organiztionId + "/owner";
            await FetchHandler.patchJson(url, p);
            await ops.loadOrgUsers(organiztionId);
        }
    }

}
